export default "/assets/images/mila-living-room-people.bcd45ceaafb31f81.webp";